import PropTypes from 'prop-types';

/**
 * Component to conditionally wrap another React component
 * based on supplied logic
 * @example:
 * const condition = 0 === 0;
 * const wrapper = children => (<View>{children}</View>);
 * <ConditionalWapper>
 *  <Text>Wrap me if condition is true!</Text>
 * </ConditionalWrapper>
 *
 * returns:
 *  <View><Text>Wrap me if condition is true!</Text></View>
*/
const ConditionalWrapper = ({
  condition, wrapper, children,
}) => (
  condition ? wrapper(children) : children
);

ConditionalWrapper.propTypes = {
  /** condition to check, if resolves to true children will be wrapped */
  condition: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.func,
  ]).isRequired,
  /** function for creating wrapping component */
  wrapper: PropTypes.func.isRequired,
  /** React element to wrap if condition is true */
  children: PropTypes.node,
};

export default ConditionalWrapper;
